export enum TypeformSurveyIdEnum {
  WELCOME = 'welcome',
  PITCHBOOK = 'pitchbook',
  IBISWORLS = 'ibisworld',
  CANCELLATION = 'cancellation',
}
